module.exports = __webpack_public_path__ + "assets/img/2018_1.7bfd2568.png";